<template>
  <component
    :is="rootComponent"
    v-bind="rootProps"
    class="reports-table-cell__wrapper"
  >
    <slot />
    <template #title>
      {{ tooltipTitle }}
    </template>
  </component>
</template>

<script setup lang="ts">
import { BittsTooltip } from '@crossbeam/bitts';

import { computed } from 'vue';

const {
  trialOver = false,
  isDisabledByTier = false,
  useTooltip = false,
} = defineProps<{
  trialOver?: boolean;
  isDisabledByTier?: boolean;
  useTooltip?: boolean;
}>();

const showTooltip = computed(
  () => useTooltip && (trialOver || isDisabledByTier),
);

const rootComponent = computed(() =>
  showTooltip.value ? BittsTooltip : 'div',
);

const rootProps = computed(() =>
  showTooltip.value ? { placement: 'topRight', mountToBody: true } : {},
);

const tooltipTitle = computed(() => {
  if (isDisabledByTier) {
    return 'Upgrade to access this List';
  }
  return 'Your free trial has ended. You do not have access to this feature';
});
</script>
